module.exports = __webpack_public_path__ + "img/farzana-christopher-72.5d5a79cb.jpg";